import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getAllAgencyUserFailure, getAllAgencyUserSuccess } from '../actions/getAllAgencyUserActions';

function* getAllAgencyUser({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllAgencyUser + `?role=${payload?.role}`,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_AGENCY_USER_SUCCESS status :", response.data.status);
        console.log("GET_ALL_AGENCY_USER_SUCCESS data :", response.data.response);
        console.log("GET_ALL_AGENCY_USER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllAgencyUserSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_AGENCY_USER_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_AGENCY_USER_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_AGENCY_USER_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllAgencyUserFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllAgencyUserSaga() {
    yield takeLatest(actionTypes.GET_ALL_AGENCY_USER_REQUEST, getAllAgencyUser);
}

export default getAllAgencyUserSaga;
